<template>
  <Layout
    isMSDCustom
    :customCompanyId="companyId"
    :customBrandingRoute="brandingRoute"
    :customLandingRoute="landingRoute"
    :companyBaseInfoResp="companyBaseInfoResp"
    :companyBrandingPageInfoResp="companyBrandingPageInfoResp"
    @changeLanguage="handleChangeLanguage"
  >
    <template #bodyContent>
      <router-view v-if="company.id" class="body-content" :company="company" :webPageItems="webPageItems" @getJDChatbotContext="getJDChatbotContext"></router-view>
    </template>
  </Layout>
</template>

<script>
import { brandingRoute, landingRoute, msdPcJobListRouteMap } from './route'
import Layout from '../../pc/layout.vue'
import { addI18nProperty } from '@/i18n'
import { mapActions } from 'vuex'
import { COMPANY_PAGE_TYPE, ROOT_COMPANY_ID } from '@/constant/company'
import _ from 'lodash'

export default {
  components: {
    Layout
  },
  data () {
    return {
      brandingRoute: brandingRoute,
      landingRoute: landingRoute,
      companyId: ROOT_COMPANY_ID.MSD,
      companyBaseInfoResp: null,
      companyBrandingPageInfoResp: null,
      company: {
        logo: null
      },
      brandingPageWebpageItems: [],
      landingPageWebpageItems: []
    }
  },
  computed: {
    customCompanyId () {
      if (this.$route.meta?.customCompanyId) {
        return this.$route.meta?.customCompanyId
      }
      return this.companyId
    },
    webPageItems () {
      const pageType = this.$route.meta?.pageType
      const isBranding = pageType === COMPANY_PAGE_TYPE.BRANDING
      return isBranding ? this.brandingPageWebpageItems : this.landingPageWebpageItems
    }
  },
  beforeRouteEnter (to, from, next) {
    const pathReg = /^\/msdchina\/professionals\/.*/
    if (pathReg.test(to.path)) {
      const route = _.get(msdPcJobListRouteMap, to.meta?.customCompanyId)
      let hashStr = ''
      if (to.hash) {
        hashStr = `${to.hash.replace('#', '')}`
      }
      if (route.meta.defaultCustomFilterName) {
        hashStr = `${hashStr}${hashStr ? '&' : ''}${route.meta.defaultCustomFilterName}`
      }
      if (hashStr) {
        hashStr = `#${hashStr}`
      }
      next({ path: '/msdchina/professionals', query: to.query, hash: hashStr })
    }
    next()
  },
  created () {
    this.initPageData()
  },
  methods: {
    ...mapActions('company', ['getCompanyBaseInfo', 'getCompanyBrandingPageInfo']),
    async initPageData () {
      await Promise.all([
        this.loadCompanyInfo(),
        this.loadCompanyPageInfo()
      ])
    },
    async loadCompanyInfo () {
      this.companyBaseInfoResp = this.getCompanyBaseInfo({ id: this.customCompanyId, params: { simple_info: 1 } })
      const resp = await this.companyBaseInfoResp
      if (resp) {
        this.company = addI18nProperty(resp, 'i18nName', 'cn_name', 'name')
      }
    },
    async loadCompanyPageInfo () {
      this.companyBrandingPageInfoResp = this.getCompanyBrandingPageInfo({
        company_id: this.customCompanyId,
        language_code: this.$i18n.locale === 'en' ? 'en' : 'zh-cn'
      })
      const resp = await this.companyBrandingPageInfoResp
      if (resp) {
        const brandingPage = resp.branding_page
        const landingPage = resp.landing_page
        if (brandingPage) {
          addI18nProperty(brandingPage, 'i18nName', 'menu_cn_name', 'menu_en_name')
          this.brandingPageWebpageItems = brandingPage.webpage_items ? JSON.parse(brandingPage.webpage_items) : []
        } else {
          let url = ''
          if (_.includes([COMPANY_PAGE_TYPE.JOB_DETAIL], this.$route.meta?.pageType)) {
            url = `/recruiting/company/${this.customCompanyId}/job/${this.$route.params.jobId}/job-detail`
          } else {
            url = '/msdchina/professionals'
          }
          if (url !== this.$route.path) {
            this.$router.push({
              path: url,
              query: this.$route.query,
              hash: this.$route.hash
            })
          }
        }
        if (landingPage) {
          addI18nProperty(landingPage, 'i18nName', 'menu_cn_name', 'menu_en_name')
          this.landingPageWebpageItems = landingPage.webpage_items ? JSON.parse(landingPage.webpage_items) : []
        }
      }
    },
    getJDChatbotContext (contentInfo) {
      this.showChatbot = false
      this.$nextTick(() => {
        this.jobDetailChatbotContent = contentInfo
        this.showChatbot = this.company.show_chatbot
      })
    },
    async handleChangeLanguage () {
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.loadCompanyPageInfo()
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
